import React, { useCallback, useEffect, useRef } from 'react'
import icons from '../assets/icons'

type Props = {
  panorama: any

  closePanorama: () => void
}

const Panorama: React.FC<Props> = ({ panorama, closePanorama }: Props) => {
  const ref = useRef<HTMLDivElement>(null)

  const getCustomPanoramaTileUrl = useCallback(
    (pano: string, zoom: number, tileX: number, tileY: number) => {
      return panorama.poi_visuel_360
    },
    [panorama],
  )

  const getCustomPanorama = useCallback(() => {
    return {
      tiles: {
        tileSize: new google.maps.Size(2048, 1024),
        worldSize: new google.maps.Size(2048, 1024),
        centerHeading: 105,
        getTileUrl: getCustomPanoramaTileUrl,
      },
    } as google.maps.StreetViewPanoramaData
  }, [getCustomPanoramaTileUrl])

  useEffect(() => {
    const options = {
      pano: 'custom',
      panoProvider: getCustomPanorama,
    }
    const element = document.getElementById('panorama')
    if (element) {
      element.style.display = 'block'
      new google.maps.StreetViewPanorama(element, options)
    }
  }, [getCustomPanorama])

  if (panorama) {
    return (
      <div ref={ref} id='panorama'>
        <div className='close-panorama' onClick={closePanorama}>
          <img src={icons.cross} alt='close' className='close-panorama--text' />
        </div>
      </div>
    )
  }
  return null
}

export default Panorama
